import React, { useState, useEffect } from "react";
import axios from "axios";
import "./StaffManagement.css";

const StaffManagement = () => {
  const [staff, setStaff] = useState([]);
  const [newStaff, setNewStaff] = useState({
    name: "",
    email: "",
    phone: "",
  });

  useEffect(() => {
    fetchStaff();
  }, []);

  const fetchStaff = async () => {
    try {
      const response = await axios.get(
        "https://api.highbridgegroup.ng/api/staff"
      );
      setStaff(response.data);
    } catch (error) {
      console.error("Error fetching staff:", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        "https://api.highbridgegroup.ng/api/staff",
        newStaff
      );
      alert(response.data.message || "Staff created successfully!");
      setNewStaff({ name: "", email: "", phone: "" });
      fetchStaff();
    } catch (error) {
      console.error("Error creating staff:", error);
      alert("Error: " + (error.response?.data?.message || "An error occurred"));
    }
  };

  return (
    <div className="staff-management-container">
      <div className="header">
        <img
          src="/assets/images/logo/highbridge2.png"
          alt="Logo"
          className="logo"
        />
        <h2 className="title">Staff Management</h2>
      </div>

      <form onSubmit={handleSubmit} className="staff-form">
        <label>
          Name:
          <input
            type="text"
            value={newStaff.name}
            onChange={(e) => setNewStaff({ ...newStaff, name: e.target.value })}
            required
          />
        </label>

        <label>
          Email:
          <input
            type="email"
            value={newStaff.email}
            onChange={(e) =>
              setNewStaff({ ...newStaff, email: e.target.value })
            }
            required
          />
        </label>

        <label>
          Phone:
          <input
            type="text"
            value={newStaff.phone}
            onChange={(e) =>
              setNewStaff({ ...newStaff, phone: e.target.value })
            }
            required
          />
        </label>

        <button type="submit" className="submit-btn">
          Add Staff
        </button>
      </form>

      <h3>Staff List</h3>
      <div className="staff-table-container">
        <table className="staff-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Phone</th>
            </tr>
          </thead>
          <tbody>
            {staff.map((member) => (
              <tr key={member._id}>
                <td>{member.name}</td>
                <td>{member.email}</td>
                <td>{member.phone}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default StaffManagement;
